import { recordEvent } from '../core';

export default class recordClick {
  constructor(el) {
    this.dataset = el.dataset;
    el.addEventListener(this.dataset.eventTrigger, () => 
      recordEvent(...this.getEventData()));
  }

  getEventData() {
    return [
      this.dataset.eventCategory,
      this.dataset.eventAction,
      this.dataset.eventLabel,
    ];
  }

}